import React, { useEffect, useRef, useState } from 'react';
import { Button, DatePicker, Form, Modal, Select } from 'antd';
import { CreateFormWrapper, CreateModalWrapper, ModalCloseBox } from '../employees/EmployeesStyle';
import { DropdownIconNew, ModalCloseIcon } from '../../theme/SvgIcons';
import { FieldBox, FlexWrapper, GridBox } from '../../theme/common_style';
import { useSelector } from 'react-redux';
import { ApplyLeaveApi, EditLeaveApi } from '../../redux/lms/apiRoute';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { halfDayOptions, leave_type, leaveOptions } from '../../utils/constant';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import dayjs from 'dayjs';
import useLeaveReqManager from '../../hooks/useLeaveReqManager';
import { useResponsiveModalWidth } from '../../hooks/useResponsiveModalWidth';
import styled from '@emotion/styled';

const AddLeave = ({ open, onClose, fetchData, updateGraph, editData = false }) => {
  const width = useResponsiveModalWidth(1000);
  const [form] = Form.useForm();
  const { data, isEmployee } = useSelector((e) => e.userInfo);
  const [loading, setLoading] = useState(false);
  const { options, loading: reportingLoading } = useLeaveReqManager();
  const quillRef = useRef(null);

  const handleCreate = async () => {
    setLoading(true);
    try {
      const finalData = await form.validateFields();
      finalData.start_date = finalData.start_date.format('YYYY-MM-DD');
      finalData.reporting = [finalData.reporting];
      if (
        form.getFieldValue('leave_category') === 'HD' ||
        form.getFieldValue('leave_category') === 'SL'
      ) {
        finalData['end_date'] = finalData.start_date;
      } else {
        finalData.end_date = finalData.end_date?.format('YYYY-MM-DD');
      }

      const ApiUrl = editData ? EditLeaveApi : ApplyLeaveApi;

      const res = await ApiUrl(
        {
          ...finalData,
          ['employee_id']: data?.user_details?.id,
          ['leave_status']: 'pending'
        },
        editData && editData?.id
      );
      if (res.statusCode === 200) {
        toast.success(res?.message);
        form.resetFields();
        onClose();
        fetchData();
        updateGraph();
      } else {
        toast.warning(res?.message);
      }
    } catch (errorInfo) {
      if (errorInfo.errorFields.length > 0) {
        form.scrollToField(errorInfo.errorFields[0].name);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (editData) {
      form.setFieldsValue({
        leave_type: editData?.leave_type,
        leave_category: editData?.leave_category,
        reporting: editData?.reporting[0] || null,
        start_date: editData?.start_date ? dayjs(editData?.start_date) : null,
        end_date: editData?.end_date ? dayjs(editData?.end_date) : null,
        reason: editData?.reason || ''
      });
      if (editData?.leave_category === 'HD' || editData?.leave_category === 'SL') {
        form.setFieldsValue({
          leave_slot: editData?.leave_slot || ''
        });
      }
    }
  }, [editData]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      centered
      width={width}
      maskClosable={false}
      footer={null}
      prefixCls="create-employees"
      closeIcon={false}>
      <CreateModalWrapper>
        <ModalCloseBox onClick={onClose}>
          <ModalCloseIcon />
        </ModalCloseBox>
        <div className="title">
          <h2>{editData ? 'Edit' : 'Add'} Leave</h2>
        </div>

        <Form autoComplete="off" form={form} onFinish={handleCreate}>
          {() => (
            <>
              <CreateFormWrapper>
                <GridBoxInput cols={2}>
                  <FieldBox>
                    <label htmlFor="leave_type">
                      Leave Type <span>*</span>
                    </label>
                    <Form.Item
                      name="leave_type"
                      rules={[{ required: true, message: 'Leave type is required' }]}>
                      <Select
                        prefixCls="form-select"
                        allowClear
                        style={{ marginBottom: '10px' }}
                        suffixIcon={<DropdownIconNew />}
                        placeholder="--Select Option--"
                        options={leave_type}
                      />
                    </Form.Item>
                  </FieldBox>
                  <FieldBox>
                    <label htmlFor="leave_category">
                      Leave Category <span>*</span>
                    </label>
                    <Form.Item
                      name="leave_category"
                      rules={[{ required: true, message: 'Leave category is required' }]}>
                      <Select
                        prefixCls="form-select"
                        allowClear
                        style={{ marginBottom: '10px' }}
                        suffixIcon={<DropdownIconNew />}
                        placeholder="--Select Option--"
                        options={leaveOptions}
                      />
                    </Form.Item>
                  </FieldBox>
                </GridBoxInput>
                <GridBoxInput cols={2}>
                  <FieldBox>
                    <label htmlFor="start_date">
                      Start Date <span>*</span>
                    </label>
                    <Form.Item
                      name="start_date"
                      rules={[{ required: true, message: 'Start Date is required' }]}>
                      <DatePicker
                        placeholder="DD/MM/YYYY"
                        prefixCls="form-datepicker"
                        format="DD/MM/YYYY"
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                  </FieldBox>
                  {form?.getFieldValue('leave_category') === 'HD' ||
                  form?.getFieldValue('leave_category') === 'SL' ? (
                    <FieldBox>
                      <label htmlFor="leave_slot">
                        Leave Slot <span>*</span>
                      </label>
                      <Form.Item
                        name="leave_slot"
                        rules={[{ required: true, message: 'Leave slot is required' }]}>
                        <Select
                          prefixCls="form-select"
                          allowClear
                          style={{ marginBottom: '10px' }}
                          suffixIcon={<DropdownIconNew />}
                          placeholder="--Select Option--"
                          options={halfDayOptions}
                        />
                      </Form.Item>
                    </FieldBox>
                  ) : (
                    <FieldBox>
                      <label htmlFor="end_date">
                        End Date <span>*</span>
                      </label>
                      <Form.Item
                        name="end_date"
                        rules={[{ required: true, message: 'End date is required' }]}>
                        <DatePicker
                          placeholder="DD/MM/YYYY"
                          prefixCls="form-datepicker"
                          format="DD/MM/YYYY"
                          style={{ width: '100%' }}
                          disabledDate={(current) => {
                            const startDate = form.getFieldValue('start_date');
                            return current && (!startDate || current < startDate.startOf('day'));
                          }}
                        />
                      </Form.Item>
                    </FieldBox>
                  )}
                </GridBoxInput>
                <GridBox>
                  <FieldBox>
                    <label htmlFor="reporting">Reporting</label>
                    <Form.Item name="reporting">
                      <Select
                        loading={reportingLoading}
                        prefixCls="form-select"
                        suffixIcon={<DropdownIconNew />}
                        placeholder="--Select Option--">
                        {options
                          ?.filter((el) => !(isEmployee && el?.value === data?.user_details?.id))
                          .map((el) => (
                            <Select.Option key={el?.value} value={el?.value}>
                              {el?.label}
                            </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </FieldBox>
                </GridBox>
                <FieldBox>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}>
                    <label htmlFor="reason">
                      Reason <span>*</span>
                    </label>
                    <span style={{ color: '#9F9F9F', fontSize: '12px', fontWeight: '400' }}>
                      Max 1000 Characters
                    </span>
                  </div>
                  <Form.Item
                    name="reason"
                    rules={[
                      {
                        validator: () => {
                          const editor = quillRef.current?.getEditor();
                          const plainText = editor?.getText().trim();

                          if (!plainText) {
                            return Promise.reject(new Error('Reason is required'));
                          }

                          if (plainText.length > 1000) {
                            return Promise.reject(new Error('Max 1000 Characters only.'));
                          }

                          return Promise.resolve();
                        }
                      }
                    ]}>
                    <ReactQuill
                      placeholder="Write your reason here"
                      ref={quillRef}
                      style={{
                        border: '1px solid #d9d9d9',
                        borderRadius: '6px'
                      }}
                      modules={{
                        toolbar: [
                          ['bold', 'italic', 'underline', 'strike'],
                          [{ list: 'ordered' }, { list: 'bullet' }]
                        ]
                      }}
                      className="custom-quill"
                    />
                  </Form.Item>
                </FieldBox>
              </CreateFormWrapper>

              <FlexWrapper
                justify={'end'}
                gap={'10px'}
                style={{ marginTop: '20px' }}
                cursor="default">
                <Button
                  loading={loading}
                  onClick={form.submit}
                  style={{ width: '140px' }}
                  prefixCls="antCustomBtn">
                  {editData ? 'Update' : 'Send'}
                </Button>
              </FlexWrapper>
            </>
          )}
        </Form>
      </CreateModalWrapper>
    </Modal>
  );
};

export default AddLeave;

AddLeave.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired,
  updateGraph: PropTypes.func.isRequired,
  editData: PropTypes.any
};
const GridBoxInput = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ cols }) => `repeat(${cols}, 1fr)`};
  gap: ${({ gap }) => gap || '16px'};

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
